import script from "./HeaderShops.vue?vue&type=script&lang=ts&setup=true"
export * from "./HeaderShops.vue?vue&type=script&lang=ts&setup=true"

import "./HeaderShops.vue?vue&type=style&index=0&id=0d4e4b20&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d4e4b20"]])

export default __exports__